import { FirmaDigitalService as Base } from '@colescba/services'

const removeVersionFromUrl = url => {
  if (url.endsWith('/v1') || url.endsWith('/v2')) {
    return url.slice(0, -3)
  }

  return url
}

export class FirmaDigitalService extends Base {
  /**
   * Devuelve la lista de firmantes. También verifica, por cada firma, si es la firma de proceso de ColEscBA.
   * La verificación se realiza con los valores de los atributos 'CERTITICADO_ATRIBUTO_NOMBRE' y 'CERTITICADO_ATRIBUTO_VALOR'.
   * Se controlan todos los atributos que existen en el JSON resultante (FirmantePdfResponse) hasta encontrar el atributo con
   * nombre 'CERTITICADO_ATRIBUTO_NOMBRE' y se compara su valor contra 'CERTITICADO_ATRIBUTO_VALOR'.
   *
   * Se espera recibir como Body de este requerimiento, el PDF firmado encodeado en base64.
   *
   * @param {String } archivoBase64
   *
   * @returns {Promise<import('@colescba/services/dist/firma-digital/types').FirmaDigital.FirmantePdfType[]>}
   */
  async listaFirmantes(archivoBase64) {
    const baseURL = removeVersionFromUrl(this.baseURL) + '/v2'

    const response = await this.http.post('/lista-firmantes', archivoBase64, {
      baseURL,
      headers: {
        'content-type': 'text/plain',
      },
    })

    return response.data
  }
}
